if (!customElements.get('wishlist-btn')) {
  class WishlistBtn extends HTMLElement {
    static STORAGE_KEY = 'wishlist';

    get wishlist() {
      try {
        return JSON.parse(localStorage.getItem(WishlistBtn.STORAGE_KEY)) || [];
      } catch {
        return [];
      }
    }

    set wishlist(list) {
      localStorage.setItem(
        WishlistBtn.STORAGE_KEY,
        JSON.stringify(list)
      );
    }

    connectedCallback() {
      this.handle = this.dataset.productHandle;
      if (!this.handle) return;

      this.render();
      this.addEventListener('click', this.toggle.bind(this));
    }

    toggle(e) {
      e.preventDefault();
      e.stopPropagation();

      let list = this.wishlist;
      let removed = false;

      if (list.includes(this.handle)) {
        list = list.filter(h => h !== this.handle);
        removed = true;
      } else {
        list.push(this.handle);
      }

      this.wishlist = list;
      this.render();

      if (removed) {
        this.dispatchEvent(
          new CustomEvent('wishlist:removed', {
            bubbles: true,
            detail: {
              handle: this.handle
            }
          })
        );
      }
    }

    render() {
      const active = this.wishlist.includes(this.handle);

      this.innerHTML = `
        <button class="wishlist-btn" aria-label="${active ? 'Remove from wishlist' : 'Add to wishlist'}">
          <img src="${active ? window.wishlistFilled : window.wishlistOutline}" width="24" height="24" alt="" style="filter: ${active ? `invert(25%) sepia(26%) saturate(4110%) hue-rotate(335deg) brightness(95%) contrast(100%)` : `unset`}" />
        </button>
      `;
    }
  }

  customElements.define('wishlist-btn', WishlistBtn);
}
